import { Log } from '@/types/logs'
import { IMechanicalInformation } from '@/types/mechanicalInformation'
import { FormValuesType } from '../schema'
import { MECHANICAL_INFORMATION_FORM_FIELDS } from '../constant'
import { parseDate } from '@/helpers/time'

const formatDefaultValue = <T>(info: IMechanicalInformation, key: keyof IMechanicalInformation): T | undefined =>
    (info[key] as T) ?? undefined

export const buildMechanicalInformationDefaultValues = (log?: Log): Partial<FormValuesType> => {
    if (!log?.mechanicalInfo) {
        return {
            [MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared]: parseDate(new Date().toISOString()).time,
            [MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime]: parseDate(new Date().toISOString()).time,
        }
    }

    return {
        [MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared]: parseDate(
            log.mechanicalInfo?.timeCleared || new Date().toISOString()
        ).time,
        [MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime]: parseDate(
            log.mechanicalInfo?.substitutionTime || new Date().toISOString()
        ).time,
        [MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber]: formatDefaultValue(log.mechanicalInfo, 'subbedBonnetNumber'),
        [MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus]: formatDefaultValue(
            log.mechanicalInfo,
            'busAuthorizedStatus'
        ),
        [MECHANICAL_INFORMATION_FORM_FIELDS.contactTimeDetails]: formatDefaultValue(
            log.mechanicalInfo,
            'timeEngineeringContactedDetails'
        ),
        [MECHANICAL_INFORMATION_FORM_FIELDS.usedTranzaura]: formatDefaultValue(
            log.mechanicalInfo,
            'tranzauraUsageType'
        ),
        [MECHANICAL_INFORMATION_FORM_FIELDS.engineeringStatement]: formatDefaultValue(
            log.mechanicalInfo,
            'engineeringStatement'
        ),
    }
}
